var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1677_107789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 26.3332L23.5 22.9999M23.5 22.9999L20.1667 26.3332M23.5 22.9999V30.4999M30.4917 28.3249C31.3044 27.8818 31.9465 27.1806 32.3166 26.3321C32.6866 25.4835 32.7635 24.5359 32.5352 23.6388C32.3068 22.7417 31.7862 21.9462 31.0556 21.3778C30.3249 20.8094 29.4257 20.5005 28.5 20.4999H27.45C27.1978 19.5243 26.7276 18.6185 26.075 17.8507C25.4223 17.0829 24.604 16.4731 23.6817 16.0671C22.7595 15.661 21.7571 15.4694 20.7501 15.5065C19.7431 15.5436 18.7576 15.8085 17.8676 16.2813C16.9777 16.7541 16.2066 17.4225 15.6122 18.2362C15.0178 19.05 14.6156 19.9879 14.4358 20.9794C14.2561 21.9709 14.3034 22.9903 14.5743 23.961C14.8453 24.9316 15.3327 25.8281 16 26.5832",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1677_107789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cff72a6a8909dd6ef42c05c38a184174.svg";
export { ForwardRef as ReactComponent };